import {
  ShiftCourierJson,
  ShiftCourierJsonForCourier,
  ShiftCourierWithDateJson,
} from 'const/ShiftConst';
import dayjs, { Dayjs } from 'dayjs';
import { Region } from 'types/orderTypes';
import { settings } from '../settings';
import Fetch from '../utils/fetch';
import { queryStringFromObject } from 'utils/urlUtil';
import { CourierInvoice } from '../types/reportTypes';
import { getUserSelectedRegion } from '../lib/AuthClient/userPreferences';

export async function shiftFetchByRegion(
  startDate: string,
  endDate: string,
  region: Region
): Promise<ShiftCourierWithDateJson[]> {
  const queryParams = {
    start: startDate,
    end: endDate,
    region: region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.get({
    url: `${settings.newApiUrl}/shift/byRegion${queryString}`,
  });
  const shiftList: ShiftCourierWithDateJson[] = await response.json();
  return shiftList;
}

export async function shiftFetch(
  startDate: string,
  endDate: string
): Promise<ShiftCourierWithDateJson[]> {
  const queryParams = {
    start: startDate,
    end: endDate,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.get({
    url: `${settings.newApiUrl}/shift${queryString}`,
  });
  const shiftList: ShiftCourierWithDateJson[] = await response.json();
  return shiftList;
}

export async function fetchShiftWithOnlyExtraWork(
  startDate: string,
  endDate: string,
  region: string
): Promise<CourierInvoice[]> {
  const queryParams = {
    start: startDate,
    end: endDate,
    region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.get({
    url: `${settings.newApiUrl}/shift/onlyExtraWorkShifts${queryString}`,
  });
  return (await response.json()) as CourierInvoice[];
}

export async function updateShiftAsync(
  spotId: string,
  shiftSpot: ShiftCourierJson
): Promise<boolean> {
  const region = getUserSelectedRegion();
  const queryParams = {
    region: region,
  };
  const queryString = queryStringFromObject(queryParams);
  const response: Response = await Fetch.post({
    url: `${settings.newApiUrl}/shift/${spotId}${queryString}`,
    body: { ...shiftSpot },
  });

  const updatedSpot: boolean = response.ok;
  return updatedSpot;
}

export async function updateShiftStatusAsyncForCourier(
  spotId: string,
  shiftSpot: ShiftCourierJsonForCourier
): Promise<boolean> {
  const response: Response = await Fetch.post({
    url: `${settings.newApiUrl}/shift/${spotId}/status`,
    body: { ...shiftSpot },
  });

  const updatedSpot: boolean = response.ok;
  return updatedSpot;
}

export async function createNewShiftList(
  shiftSpotList: any[],
  region: Region
): Promise<boolean> {
  const queryParams = {
    region: region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.put({
    url: `${settings.newApiUrl}/shift/createNewShift${queryString}`,
    body: shiftSpotList,
  });

  const updatedSpot = Boolean(response.ok);
  return updatedSpot;
}

export async function addExtraWorkToShiftList(
  shiftSpotList: ShiftCourierJson[]
): Promise<boolean> {
  const region = getUserSelectedRegion();
  const queryParams = {
    region: region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.post({
    url: `${settings.newApiUrl}/shift/updateList${queryString}`,
    body: { shiftSpots: shiftSpotList },
  });

  console.log('response in addExtraWorkToShiftList', response);

  const updatedSpot: boolean = response.ok;
  return updatedSpot;
}

export async function createWishShiftAsync(
  shiftDateDayjs: Dayjs,
  name: string,
  region: Region
): Promise<ShiftCourierJson> {
  const day: string = dayjs(shiftDateDayjs).format('YYYY-MM-DD');

  const queryParams = {
    region: region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.put({
    url: `${settings.newApiUrl}/shift/createWishShift${queryString}`,
    body: { day, name },
  });

  const createdSpot: ShiftCourierJson = await response.json();
  return createdSpot;
}

export async function createShiftAsync(
  shiftDateDayjs: Dayjs,
  region: Region
): Promise<ShiftCourierJson> {
  const day: string = dayjs(shiftDateDayjs).format('YYYY-MM-DD');

  const queryParams = {
    region: region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response: Response = await Fetch.put({
    url: `${settings.newApiUrl}/shift/createOpenShift${queryString}`,
    body: { day },
  });

  const createdSpot: ShiftCourierJson = await response.json();
  return createdSpot;
}
